export const content = {
  contact: {
    name: "Alessandro Di Rienzo",
    phone: "+39 347 810 9745",
    email: "info@foodyburger49.it",
    instagram: "@foodyburger49",
    location: "Piemonte – Operativo in tutta Europa"
  },
  
  hero: {
    authorityLine: "Brand Activation Vehicle • Experiential Marketing • Roadshow Asset",
    headline: "Non è un food truck.",
    subHeadline: "È una piattaforma di brand experience su ruote.",
    description: "Ford F68 del 1949 trasformato in asset premium per roadshow, lanci prodotto ed eventi corporate in tutta Europa.",
    trustLine: "Trusted for corporate events, product launches and experiential tours.",
    cta: {
      primary: "Richiedi una proposta personalizzata",
      secondary: "Scarica il media kit professionale"
    }
  },
  
  about: {
    title: "Un'icona americana. Una visione italiana.",
    founder: {
      name: "Alessandro Di Rienzo",
      experience: "Dieci anni in un contesto multinazionale globale come FCA, oggi Stellantis. Un’esperienza che oggi si traduce in metodo e struttura nel mondo degli eventi.",
      story: "Foody Burger 49 nasce dall’integrazione tra mentalità corporate e cultura dell’ospitalità, con l’obiettivo di offrire ai brand un partner operativo, strutturato e orientato ai risultati."
    },
    mission: "Portare il senza glutine dove ancora non c'è.",
    truck: {
      model: "Ford F68 – 1949",
      origin: "Importato dagli USA",
      restoration: "Restaurato in Italia",
      style: "Vintage American Style",
      features: [
        "Asset scenografico brandizzabile ad alto impatto visivo",
        "Piattaforma mobile ideale per eventi e campagne marketing",
        "Cucina professionale 100% gluten free certificata",
        "Experiential vehicle per brand activation su strada"
      ]
    }
  },
  
  whyChoose: [
    {
      title: "Asset Scenografico Premium",
      description: "Icona vintage americana del 1949 ad altissimo impatto visivo per eventi e campagne memorabili.",
      icon: "Eye"
    },
    {
      title: "Piattaforma Completamente Brandizzabile",
      description: "Personalizzazione grafica totale per trasformare il veicolo nella tua brand extension su strada.",
      icon: "Palette"
    },
    {
      title: "Operativo per Roadshow Multicittà",
      description: "Disponibile in tutta Europa per campagne di experiential marketing e tour promozionali su larga scala.",
      icon: "MapPin"
    },
    {
      title: "Esperienza di Brand Inclusiva",
      description: "Hospitality 100% gluten free per coinvolgere target di mercato ampi e diversificati.",
      icon: "Users"
    },
    {
      title: "Generatore di Contenuti Social",
      description: "Asset altamente fotografabile che genera contenuto autentico e amplificazione organica sui social.",
      icon: "Camera"
    },
    {
      title: "Certificazioni Professionali Complete",
      description: "HACCP, SAB e sicurezza alimentare certificati per partnership con brand e aziende internazionali.",
      icon: "Award"
    }
  ],
  
  howItWorks: {
    title: "Come Funziona",
    subtitle: "Dal concept all'esecuzione, un processo studiato per garantire la massima qualità della tua attivazione.",
    steps: [
      {
        number: "01",
        title: "Concept & Personalizzazione",
        description: "Definiamo insieme obiettivi, target e strategia. Personalizziamo il veicolo con la tua brand identity."
      },
      {
        number: "02",
        title: "Attivazione & Produzione",
        description: "Esecuzione operativa del tour o evento con team dedicato e setup professionale certificato."
      },
      {
        number: "03",
        title: "Impatto & Amplificazione",
        description: "Un asset che genera contenuti, engagement organico e visibilità social naturale durante l'attivazione."
      }
    ]
  },
  
  services: {
    brandMarketing: {
      title: "Brand Activation & Marketing",
      items: [
        "Attivazioni di Brand Strategiche",
        "Roadshow Multicittà",
        "Esperienze di Lancio Prodotto",
        "Eventi Corporate ad Alto Impatto",
        "Tour di Experiential Marketing",
        "Noleggio Asset Scenografico Premium"
      ]
    },
    shootingMedia: {
      title: "Content & Media Production",
      items: [
        "Set Fotografici Professionali",
        "Produzione Video e Riprese",
        "Integrazione Campagne ADV",
        "Collaborazioni con Influencer & Creator",
        "Creazione Contenuti Brandizzati",
        "Asset per Attivazioni Social"
      ]
    },
    eventFood: {
      title: "Event Hospitality",
      items: [
        "Attivazioni Pubbliche su Larga Scala",
        "Eventi Corporate Hospitality",
        "Eventi Privati Premium",
        "Cerimonie di Alto Livello",
        "Collaborazioni con Comuni",
        "Partnership con Enti Turistici"
      ]
    }
  },
  
  menu: {
    title: "Esperienza Hospitality Inclusiva",
    subtitle: "100% Gluten Free. Certificato. Professionale.",
    description: "Offerta gastronomica premium studiata per garantire massima inclusività ai tuoi eventi corporate e brand activation.",
    items: [
      {
        name: "Selezione Burger Gourmet",
        description: "Linea premium burger con pane artigianale certificato gluten free"
      },
      {
        name: "Schiacciate Italiane",
        description: "Focacce tradizionali italiane in versione inclusiva"
      },
      {
        name: "Patatine Signature",
        description: "Patatine croccanti in olio dedicato, 100% celiac-safe"
      },
      {
        name: "Crêpes Fresche",
        description: "Dolci e salate preparate al momento per hospitality premium"
      },
      {
        name: "Bubble Waffle Americani",
        description: "Specialità USA in versione senza glutine"
      }
    ],
    certifications: ["HACCP", "SAB", "Sicurezza Alimentare", "Gluten Free Certified"]
  },
  
  gallery: {
    captions: {
      truck: "Asset scenografico premium",
      brandActivation: "Esempio di brand activation",
      roadshow: "Setup roadshow",
      productLaunch: "Setup lancio prodotto",
      corporate: "Hospitality corporate",
      detail: "Dettaglio asset vintage",
      event: "Experiential marketing"
    }
  }
};
